import { useRouter } from "next/router";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import MDXPageEN from "@components/aboutUs/about_us_en.mdx";
import MDXPagePL from "@components/aboutUs/about_us_pl.mdx";

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}

const ThemedPage = () => {
  const { locale } = useRouter();

  return <>{locale === "pl" ? <MDXPagePL /> : <MDXPageEN />}</>;
};

export default function About() {
  return <ThemedPage />;
}
